import { render, staticRenderFns } from "./card_list.vue?vue&type=template&id=63b4ed95&"
import script from "./card_list.vue?vue&type=script&lang=js&"
export * from "./card_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports